import { useEffect, useState } from "react";
import { OPERATORS } from "@/lib/api";
import { PtBadge } from "@/components/PtBadge";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const cb = "border-slate-400 data-[state=checked]:bg-emerald-500 data-[state=checked]:border-emerald-500 data-[state=indeterminate]:bg-emerald-500/60";

export function SimFilterDialog({ open, onClose, items, selected, onApply, scope, colors }) {
  const [draft, setDraft] = useState(selected);
  const [q, setQ] = useState("");
  useEffect(() => { if (open) { setDraft(selected); setQ(""); } }, [open, selected]);
  const shown = items.filter((n) => n.name.toLowerCase().includes(q.toLowerCase()));
  const vals = shown.map((n) => n.key);
  const on = vals.filter((v) => draft.includes(v)).length;
  const all = !vals.length || on === 0 ? false : on === vals.length ? true : "indeterminate";
  const toggle = (v) => setDraft((d) => (d.includes(v) ? d.filter((x) => x !== v) : [...d, v]));
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="sim-filter-dialog" className="bg-white border-slate-300 max-w-sm p-0 gap-0">
        <DialogHeader className="p-4 pb-2">
          <DialogTitle className="font-display text-2xl">Filter SIM</DialogTitle>
          <p data-testid="sim-filter-scope" className="text-xs text-slate-500">{scope}</p>
        </DialogHeader>
        <div className="px-4 pb-2"><Input data-testid="sim-filter-search" placeholder="Cari nama SIM…" value={q} onChange={(e) => setQ(e.target.value)} className="h-9 bg-white" /></div>
        <div className="flex items-center gap-2 px-4 py-2 text-sm border-y border-slate-200">
          <Checkbox id="sf-all" data-testid="sim-filter-all" checked={all} className={cb}
            onCheckedChange={() => setDraft((d) => (all === true ? d.filter((x) => !vals.includes(x)) : [...new Set([...d, ...vals])]))} />
          <label htmlFor="sf-all" className="cursor-pointer">Semua ({shown.length})</label>
          <span className="text-slate-400">|</span>
          <button data-testid="sim-filter-invert" className="text-xs text-emerald-700 hover:underline"
            onClick={() => setDraft((d) => [...d.filter((x) => !vals.includes(x)), ...vals.filter((x) => !d.includes(x))])}>Balik pilihan</button>
        </div>
        <div className="max-h-[50vh] overflow-y-auto py-1">
          {shown.map((n) => (
            <label key={n.key} className="flex items-center gap-2 px-4 py-1.5 text-sm hover:bg-slate-100 cursor-pointer">
              <Checkbox data-testid={`sim-filter-item-${n.name}${n.company ? `-${n.company}` : ""}`} checked={draft.includes(n.key)} onCheckedChange={() => toggle(n.key)} className={cb} />
              <span className="font-semibold text-emerald-600">{n.name}</span>
              <PtBadge name={n.company} colors={colors} />
              <span className="text-[11px] font-mono text-slate-500">({n.total})</span>
              <span className={`ml-auto text-[10px] font-mono ${OPERATORS[n.operator]?.color || "text-slate-500"}`}>{OPERATORS[n.operator]?.short || ""}</span>
            </label>
          ))}
          {!shown.length && <p className="text-xs text-slate-500 px-4 py-3">Tidak ada SIM untuk filter ini.</p>}
        </div>
        <div className="flex items-center gap-2 p-3 border-t border-slate-200">
          <span className="text-[11px] text-slate-500">{draft.length} dipilih</span>
          <Button data-testid="sim-filter-cancel" variant="outline" size="sm" className="ml-auto" onClick={onClose}>Batal</Button>
          <Button data-testid="sim-filter-ok" size="sm" className="bg-emerald-500 hover:bg-emerald-600 text-white px-5" onClick={() => { onApply(draft); onClose(); }}>OK</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
